export const DndTypes = {
  TIMELINE_SONG: 'TIMELINE_SONG',
  TIMELINE_QUESTION: 'TIMELINE_QUESTION',
  SECTION: 'SECTION',
  PLAYLIST_SONG: 'PLAYLIST_SONG',
  SELECTED_PLAYLIST: 'SELECTED_PLAYLIST',
  QUESTION_OPTION: 'QUESTION_OPTION',
  CUSTOM_NOTIF: 'CUSTOM_NOTIF',
  ACADEMY_COURSE: 'ACADEMY_COURSE',
};
